function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.1304 8.19565H18.8889C17.4512 5.90096 14.9078 4.36957 12 4.36957C9.09217 4.36957 6.54878 5.90096 5.11113 8.19565H3.86957C2.28461 8.19565 1 9.48026 1 11.0652V13.9348C1 15.5197 2.28461 16.8044 3.86957 16.8044H5.11113C6.54878 19.099 9.09217 20.6304 12 20.6304C14.9078 20.6304 17.4512 19.099 18.8889 16.8044H20.1304C21.7154 16.8044 23 15.5197 23 13.9348V11.0652C23 9.48026 21.7154 8.19565 20.1304 8.19565Z",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M5.11133 8.19568H18.8881",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M5.11133 16.8043H18.8881",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5645 16.8044C11.9275 16.8044 12.4775 13.9348 12.4775 12.5C12.4775 11.0652 13.0275 8.19568 14.3905 8.19568",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M2.91211 10.1087L4.34689 14.8913L5.78167 10.1087L7.21646 14.8913L8.65124 10.1087",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10.5645 14.8913V12.0217",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3906 14.8913V10.1087H18.2167",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M14.3906 12.9783H17.7385",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M20.1309 14.8913V12.0217",
  stroke: "#627D98",
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.0444 10.1087C11.0444 10.3727 10.8302 10.587 10.5662 10.587C10.3022 10.587 10.0879 10.3727 10.0879 10.1087C10.0879 9.84469 10.3022 9.63043 10.5662 9.63043C10.8302 9.63043 11.0444 9.84469 11.0444 10.1087",
  fill: "#627D98"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.6089 10.1087C20.6089 10.3727 20.3946 10.587 20.1306 10.587C19.8666 10.587 19.6523 10.3727 19.6523 10.1087C19.6523 9.84469 19.8666 9.63043 20.1306 9.63043C20.3946 9.63043 20.6089 9.84469 20.6089 10.1087",
  fill: "#627D98"
});

function SvgIcoWifiShared(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoWifiShared);
export default __webpack_public_path__ + "static/media/ico-wifi-shared.7ec1c191.svg";
export { ForwardRef as ReactComponent };